import { render, staticRenderFns } from "./Skillset.vue?vue&type=template&id=a253a51e&scoped=true&"
import script from "./Skillset.vue?vue&type=script&lang=js&"
export * from "./Skillset.vue?vue&type=script&lang=js&"
import style0 from "./Skillset.vue?vue&type=style&index=0&id=a253a51e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a253a51e",
  null
  
)

export default component.exports